module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-Photograph-72dpi.60d2d1d7.jpg";